import React from 'react';
import { AlertCircle, AlertTriangle, CheckCircle } from 'lucide-react';

const StockAlertBadge = ({ current, threshold }) => {
  const percentage = (current / threshold) * 100;
  
  if (percentage > 100) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-green-100 text-green-700 rounded-sm text-xs font-medium" data-testid="stock-badge-good">
        <CheckCircle className="w-3.5 h-3.5" />
        Bon
      </div>
    );
  }
  
  if (percentage > 50) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-yellow-100 text-yellow-700 rounded-sm text-xs font-medium" data-testid="stock-badge-warning">
        <AlertTriangle className="w-3.5 h-3.5" />
        Attention
      </div>
    );
  }
  
  return (
    <div className="flex items-center gap-1.5 px-2 py-1 bg-red-100 text-red-700 rounded-sm text-xs font-medium" data-testid="stock-badge-critical">
      <AlertCircle className="w-3.5 h-3.5" />
      Critique
    </div>
  );
};

export default StockAlertBadge;
